'use client';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';
import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlDescription } from '@eliadmin/core/src/components/ui/html-description';
import { Button } from '../ui/button';
import Link from '@eliadmin/core/src/components/link';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function FAQ({ title, faqs }: { title: string; faqs: TDynamicData[] }) {
  const { t } = useTranslations();
  return (
    <section
      className={cn(
        'custom-section',
        'gap-8 pb-6 pt-8 sm:gap-10 sm:pb-8 sm:pt-12 md:pb-10 lg:gap-12 lg:pb-12 lg:pt-16',
      )}
    >
      <h2 data-ea-visual-tag="h3" className="lg:text[44px] w-full max-w-[515px] text-center text-[32px] font-bold text-foreground sm:text-4xl">
        {title}
      </h2>
      <Accordion
        type="multiple"
        className="flex w-full max-w-[842px] flex-col items-center justify-center gap-4"
      >
        {faqs.map(faq => (
          <AccordionItem
            key={faq.name}
            value={faq.slug}
            className={cn(
              'ea-faq__accordion-item',
              'w-full rounded-[12px] border border-black/10 bg-white p-4 sm:p-5 lg:p-6',
            )}
          >
            <AccordionTrigger
              hideIcon
              className={cn(
                'ea-faq__accordion-trigger',
                'flex w-full items-center justify-between gap-6 p-0 text-left',
              )}
            >
              <p className="text-lg font-bold text-foreground sm:text-xl">{faq.name}</p>
            </AccordionTrigger>
            <AccordionContent className="w-full p-0 pt-4">
              <HtmlDescription
                color="muted-foreground"
                size="sm"
                content={faq.fields[0]?.value || ''}
                className={cn(
                  'w-full',
                  'ea-accordion__content-description',
                  'text-sm text-foreground sm:text-base',
                )}
              />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="flex w-full flex-col items-center justify-center gap-6">
        <p className="text-center text-sm font-semibold text-foreground sm:text-base">
          Nenašli ste odpoveď na vašu otázku?
        </p>
        <Button asChild>
          <Link prefetch={false} href={'#kontakt'}>
            {t('text612')}
          </Link>
        </Button>
      </div>
    </section>
  );
}
